import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import OrganizationAppResource from './OrganizationAppResource';

export const MOXI = 'moxi';
export const SKYSLOPE = 'skyslope';
export const FOLLOW_UP_BOSS = 'followupboss';
export const TOTAL_EXPERT = 'totalexpert';
export const INTEGRATION_TYPES = {
    MOXI,
    SKYSLOPE,
    FOLLOW_UP_BOSS,
    TOTAL_EXPERT,
};

export const STATUSES = {
    SUCCESS : 'success',
    FAILED: 'fail'
}

class OrganizationIntegrationAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'organization-integration';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'organizations/integrations';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'key',
            'organizationUuid',
            'type',
            'credential',
            'status',
            'meta',
            'enabled'
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            organization: OrganizationAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            organization: 'organization_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            organizationUuid: {
                type: 'string',
                presence: true,
            },
            type: {
                type: 'string',
            },
            status: {
                type: 'string',
            },
            credential: {

            },
            meta: {

            },
            enabled: {
                type: 'boolean',
            },
        };
    }

}

export default OrganizationIntegrationAppResource;
